import React from 'react';
import './authlock.scss';

const Authlock=()=>{
  return (
    <div className="row">
      <div className="col-xs-12">
        <div className="decline-offer-desc auth-lock-statement">
          <div className="idv-info-wrapper">
            <span className="idv-info-icon"></span>
          </div>
          <span>We're sorry, but for security reasons</span>
          <br />
          <span>online access to your account is unavailable.</span>
        </div>
      </div>
    </div>
  );
};

export default Authlock;
